/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import ExternalCertificateValidation from "./validators/ExternalCertificateValidation";
import AdobeSignCertificateValidation from "./validators/AdobeSignCertificateValidation";

// eslint-disable-next-line import/prefer-default-export
export const getCertificateValidators = externalCertificateValidator => {
    const validators = [];

    if (typeof externalCertificateValidator === "function") {
        validators.push(new ExternalCertificateValidation(externalCertificateValidator));
    }

    if (AdobeSignCertificateValidation.isAvailable()) {
        validators.push(new AdobeSignCertificateValidation());
    }

    return validators;
};
